var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from "@mui/material";
import FilteredOverviewPage from "../FilteredOverviewPage/FilteredOverviewPage";
import { CohortInsightsPageFilters } from "../Filters/Filters";
import StatusInfo from "../StatusInfo/StatusInfo";
import BarChart from "../BarChart/BarChart";
import DevelopmentOpportunitiesBar from "../DevelopmentOpportunitiesBar";
import { DistributionSet } from "../DonutChart/DistributionSet";
import { getDescriptionWithTexts } from "../DonutChart/DistributionSet";
import BackToButton from "../BackToButton";
import { getRoute } from "../../routes/getAllRoutes";
import styles from "./LeaderInsights.module.scss";
import { ImpactLevelFunctionMatrix } from "../LevelFunctionMatrix/Variants";
import { useLocation } from "react-router-dom";
import { FilterContext } from "../../providers/FilterProvider";
import LeaderCount from "../../components/LeaderCount/";
import { processOverviewData, transformeScoreData, useGetLeaderScoreCategoriesQuery, useGetLeadershipOverviewQuery, useGetLeadershipScoresQuery, useGetScoreStateQuery, } from "../../store/api/core";
import { useContext, useEffect, useState } from "react";
import { useHeatmap } from "../../hooks/heatmapScores";
import { Colors, Tab } from "../../common/cohortHelpers";
import { getColorDecider } from "../../common/action";
import { DownloadableSection } from "../DownloadableSection/DownloadableSection";
var OverallHeidrickScorePage = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    var location = useLocation();
    var _u = useState(), avgScoreData = _u[0], setAvgScoreGroupData = _u[1];
    var getFilters = useContext(FilterContext).getFilters;
    var leaderShipOverview = useGetLeadershipOverviewQuery({
        filters: getFilters(),
    });
    var scores = useGetLeadershipScoresQuery({ filters: getFilters() });
    var heidrickScoreCategories = useGetLeaderScoreCategoriesQuery({
        filters: getFilters(),
        score_type: "overall_score",
    });
    var StyledMainBg = {
        background: "var(--grey-color-10)",
        gap: "32px",
        padding: "32px",
        display: "flex",
        flexDirection: "column",
    };
    var StyledCard = {
        padding: "32px",
        background: "var(--grey-gradient-start-color-10)",
        borderRadius: "25px",
    };
    var ChartStyle = {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        gap: "40px",
        width: "100%",
    };
    var StatusDistributionStyle = {
        display: "flex",
        padding: "32px",
        flex: 1,
        minWidth: "300px",
        alignItems: "flex-start",
        background: "var(--grey-gradient-start-color-10)",
        borderRadius: "10px",
    };
    var overallHeidricChartStyle = {
        display: "flex",
        flex: 2,
        minWidth: "300px",
        padding: "32px",
        alignItems: "center",
        background: "var(--grey-gradient-start-color-10)",
        borderRadius: "10px",
    };
    var statusDistriTitle = {
        color: "var(--neutral-3)",
        fontFamily: "var(--font-stack-full-medium)",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "24px",
        marginBottom: "67px",
    };
    var heatmapTitle = {
        fontSize: "24px",
        fontWeight: "500",
        lineHeight: "32px",
        fontFamily: "var(--font-stack-full-medium)",
        marginBottom: "20px",
        color: "var(--grey-color-90)",
    };
    var barChartStyle = {
        display: "inline-block",
        position: "relative",
        width: "100%",
    };
    var title = "Cohort Insights";
    var titleGroupBy = "Groups with development opportunities";
    var headerIconColor = "var(--bad-1)";
    var colors = ["var(--bad-1)", "var(--neutral-1)", "var(--good-1)"];
    var matchStatus = [
        {
            text: "Act",
            color: {
                border: "var(--bad-2)",
                background: "var(--bad-1)",
            },
        },
        {
            text: "Watch",
            color: {
                border: "var(--neutral-2)",
                background: "var(--neutral-1)",
            },
        },
        {
            text: "Maintain",
            color: {
                border: "var(--good-2)",
                background: "var(--good-1)",
            },
        },
    ];
    var filters = getFilters();
    var arraysEmpty = Object.values(filters)
        .filter(Array.isArray)
        .every(function (arr) { return arr.length === 0; });
    var LocalLeaderCount = function (_a) {
        var _b, _c;
        var useOverview = _a.useOverview, countText = _a.countText;
        var getFilters = useContext(FilterContext).getFilters;
        var scores = useOverview({ filters: __assign({}, getFilters()) });
        var totalNumberCount = (_c = (_b = scores === null || scores === void 0 ? void 0 : scores.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.leaders;
        return (_jsx(LeaderCount, { leadersCount: totalNumberCount, countText: countText }));
    };
    useEffect(function () {
        var _a, _b;
        if ((_b = (_a = heidrickScoreCategories === null || heidrickScoreCategories === void 0 ? void 0 : heidrickScoreCategories.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.averageScoreBySkillGroup) {
            var averageScoreGroup = matchStatus === null || matchStatus === void 0 ? void 0 : matchStatus.map(function (item, key) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                return (__assign(__assign({}, (_e = (_d = (_c = (_b = (_a = heidrickScoreCategories === null || heidrickScoreCategories === void 0 ? void 0 : heidrickScoreCategories.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.averageScoreBySkillGroup) === null || _c === void 0 ? void 0 : _c.overall_score) === null || _d === void 0 ? void 0 : _d.score_levels) === null || _e === void 0 ? void 0 : _e[key]), { text: item.text, count: (_l = (_k = (_j = (_h = (_g = (_f = heidrickScoreCategories === null || heidrickScoreCategories === void 0 ? void 0 : heidrickScoreCategories.data) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.averageScoreBySkillGroup) === null || _h === void 0 ? void 0 : _h.overall_score) === null || _j === void 0 ? void 0 : _j.score_levels) === null || _k === void 0 ? void 0 : _k[key]) === null || _l === void 0 ? void 0 : _l.count, color: item.color }));
            });
            setAvgScoreGroupData(averageScoreGroup);
        }
    }, [(_a = heidrickScoreCategories === null || heidrickScoreCategories === void 0 ? void 0 : heidrickScoreCategories.data) === null || _a === void 0 ? void 0 : _a.data]);
    var notHold = function (data) { return ({
        data: data,
    }); };
    var useSeparateScores = function () {
        return useHeatmap(function () { var _a; return notHold(processOverviewData((_a = leaderShipOverview === null || leaderShipOverview === void 0 ? void 0 : leaderShipOverview.data) === null || _a === void 0 ? void 0 : _a.data)); }, function () { return notHold(transformeScoreData(scores === null || scores === void 0 ? void 0 : scores.data)); }, function () { return notHold({}); }, function () { return ({ state: "nodata" }); }, "overall_score", "overall_score");
    };
    var preParedData = function () {
        var _a, _b, _c, _d;
        var data = (_d = (_c = (_b = (_a = heidrickScoreCategories === null || heidrickScoreCategories === void 0 ? void 0 : heidrickScoreCategories.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.averageScoreBySkillGroup) === null || _c === void 0 ? void 0 : _c.scores) === null || _d === void 0 ? void 0 : _d.filter(function (item) { return item.leaderCount > 0; });
        return data;
    };
    var minScore = Array.isArray((_d = (_c = (_b = heidrickScoreCategories === null || heidrickScoreCategories === void 0 ? void 0 : heidrickScoreCategories.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.averageScoreBySkillGroup) === null || _d === void 0 ? void 0 : _d.scores) &&
        heidrickScoreCategories.data.data.averageScoreBySkillGroup.scores.length > 0
        ? Math.min.apply(Math, heidrickScoreCategories.data.data.averageScoreBySkillGroup.scores.map(function (item) { return item.score; })) : 0;
    var maxScore = Array.isArray((_g = (_f = (_e = heidrickScoreCategories === null || heidrickScoreCategories === void 0 ? void 0 : heidrickScoreCategories.data) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.averageScoreBySkillGroup) === null || _g === void 0 ? void 0 : _g.scores) &&
        heidrickScoreCategories.data.data.averageScoreBySkillGroup.scores.length > 0
        ? Math.max.apply(Math, heidrickScoreCategories.data.data.averageScoreBySkillGroup.scores.map(function (item) { return item.score; })) : 100;
    var step = 5; // or 5, as needed
    // Generate xTicks dynamically
    var xTicks = Array.from({ length: Math.floor((maxScore - minScore) / step) + 1 }, function (_, i) { return minScore + i * step; });
    return (_jsxs(_Fragment, { children: [_jsx(FilteredOverviewPage, { availableFilters: CohortInsightsPageFilters, title: title, secondaryHeadingTitle: "Overall Heidrick Score", rightTrailer: _jsx(LocalLeaderCount, { useOverview: useGetScoreStateQuery, countText: "leader" }), backToButton: _jsx(BackToButton, { title: "Cohort Insights", backUrl: getRoute("LeaderInsights") }), backgroundImage: getRoute("HeaderBackground") }), _jsxs(Box, __assign({ sx: StyledMainBg }, { children: [_jsx(Box, __assign({ className: styles.statusCardContainer }, { children: _jsx(StatusInfo, { heading: "Status", data: [
                                {
                                    text: "Act",
                                    bgColor: "var(--bad-1)",
                                    brColor: "var(--bad-2)",
                                },
                                {
                                    text: "Watch",
                                    bgColor: "var(--neutral-1)",
                                    brColor: "var(--neutral-2)",
                                },
                                {
                                    text: "Maintain",
                                    bgColor: "var(--good-1)",
                                    brColor: "var(--good-2)",
                                },
                            ] }) })), _jsxs(Box, __assign({ sx: ChartStyle }, { children: [_jsx(Box, __assign({ sx: StatusDistributionStyle }, { children: _jsx(DownloadableSection, __assign({ filename: "Donut-chart-overall-heidrick-score" }, { children: _jsxs(Box, { children: [_jsx(Box, __assign({ sx: statusDistriTitle }, { children: "Status Distribution" })), _jsx(DistributionSet, { label: "Leaders", radius: 100, margin: 70, buckets: getDescriptionWithTexts(avgScoreData ? avgScoreData : []) })] }) })) })), _jsx(Box, __assign({ sx: overallHeidricChartStyle }, { children: _jsx(DownloadableSection, __assign({ filename: "Bar-chart-overall-heidrick-score" }, { children: _jsx(Box, __assign({ sx: barChartStyle }, { children: _jsx(BarChart, { colors: Colors[Tab.Insights], title: "Spread of Overall Heidrick Scores (%)", xTicks: xTicks, formatAverageScore: function (value) { return ({
                                                text: "".concat(value, "%"),
                                                formatting: {
                                                    paddingLeft: "6px",
                                                },
                                            }); }, getScoreDescriptionText: function (score) {
                                                var colorDecider = getColorDecider(Colors["insights"]);
                                                return colorDecider(score).description.all;
                                            }, range: {
                                                minimum: Array.isArray((_k = (_j = (_h = heidrickScoreCategories === null || heidrickScoreCategories === void 0 ? void 0 : heidrickScoreCategories.data) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.averageScoreBySkillGroup) === null || _k === void 0 ? void 0 : _k.scores) &&
                                                    heidrickScoreCategories.data.data.averageScoreBySkillGroup
                                                        .scores.length > 0
                                                    ? Math.min.apply(Math, heidrickScoreCategories.data.data.averageScoreBySkillGroup.scores.map(function (item) { return item.score - 2; })) : 0,
                                                maximum: Array.isArray((_o = (_m = (_l = heidrickScoreCategories === null || heidrickScoreCategories === void 0 ? void 0 : heidrickScoreCategories.data) === null || _l === void 0 ? void 0 : _l.data) === null || _m === void 0 ? void 0 : _m.averageScoreBySkillGroup) === null || _o === void 0 ? void 0 : _o.scores) &&
                                                    heidrickScoreCategories.data.data.averageScoreBySkillGroup
                                                        .scores.length > 0
                                                    ? Math.max.apply(Math, heidrickScoreCategories.data.data.averageScoreBySkillGroup.scores.map(function (item) { return item.score + 2; })) : 100,
                                            }, data: {
                                                axisData: preParedData() || [],
                                                averageScore: Math.round((_r = (_q = (_p = heidrickScoreCategories === null || heidrickScoreCategories === void 0 ? void 0 : heidrickScoreCategories.data) === null || _p === void 0 ? void 0 : _p.data) === null || _q === void 0 ? void 0 : _q.averageScoreBySkillGroup) === null || _r === void 0 ? void 0 : _r.overallAverageScore),
                                                targetScore: 2.2,
                                                showTarget: false,
                                            } }) })) })) }))] })), _jsx(Box, __assign({ sx: StyledCard }, { children: arraysEmpty && (_jsx(DevelopmentOpportunitiesBar, { title: titleGroupBy, headerIconColor: headerIconColor, colors: colors
                                ? colors
                                : ["var(--bad-1)", "var(--neutral-1)", "var(--good-1)"], data: ((_s = location.state) === null || _s === void 0 ? void 0 : _s.groupsByData) || [] })) })), _jsx(Box, __assign({ sx: StyledCard }, { children: _jsxs(DownloadableSection, __assign({ filename: "Heatmap-overall-heidrick-score" }, { children: [_jsx(Box, __assign({ sx: heatmapTitle }, { children: "Average Overall Heidrick Score by level and function" })), ((_t = leaderShipOverview === null || leaderShipOverview === void 0 ? void 0 : leaderShipOverview.data) === null || _t === void 0 ? void 0 : _t.data) !== undefined &&
                                    (scores === null || scores === void 0 ? void 0 : scores.data) !== undefined ? (_jsx(ImpactLevelFunctionMatrix, { useHeatmapScores: useSeparateScores, riskRole: "overall_score" })) : null] })) }))] }))] }));
};
export default OverallHeidrickScorePage;
